var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Entity } from '@decahedron/entity';
import filters from 'common/filters.js';
import { sanitizeTextForMol } from 'packages/old_mol/MolTextSanitizer';
import isNil from 'common/support/isNil';
var MolJob = /** @class */ (function (_super) {
    __extends(MolJob, _super);
    function MolJob() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.id = null;
        _this.jobId = null;
        _this.titleId = null;
        _this.contractTypeId = null;
        _this.contractLengthId = null;
        _this.workingHoursId = null;
        _this.jobExperienceId = null;
        _this.jobTypeId = null;
        _this.ref = null;
        _this.name = null;
        _this.description = '';
        _this.clientCompanyName = null;
        _this.zipcode = '00100';
        _this.address = null;
        _this.salary = null;
        _this.deadlineDate = null;
        _this.startsOn = null;
        _this.sentAt = null;
        _this.applyLink = null;
        _this.status = null;
        _this.customSalaryIdentifier = 'custom';
        return _this;
    }
    Object.defineProperty(MolJob.prototype, "usesCustomSalary", {
        get: function () {
            return this.salary === this.customSalaryIdentifier;
        },
        enumerable: false,
        configurable: true
    });
    MolJob.prototype.hasCustomSalary = function () {
        this.salary = this.customSalaryIdentifier;
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    MolJob.prototype.fromJson = function (jsonData) {
        _super.prototype.fromJson.call(this, jsonData);
        if (!isNil(this.description)) {
            this.description = sanitizeTextForMol(filters.stripMarkup(this.description
                .replace(/\<\/\s*p\>/img, '\n')));
        }
        return this;
    };
    return MolJob;
}(Entity));
export { MolJob };
